import React from 'react';
type StatusType = 'positive' | 'negative' | 'no-policy' | 'restricted';
type SizeType = 'sm' | 'md' | 'lg';
interface StatusBadgeProps {
  status: StatusType;
  size?: SizeType;
  showText?: boolean;
}
const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'md',
  showText = true
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'positive':
        return 'bg-green-500';
      case 'negative':
        return 'bg-red-500';
      case 'no-policy':
        return 'bg-yellow-400';
      case 'restricted':
        return 'bg-slate-400';
      default:
        return 'bg-gray-400';
    }
  };
  const getStatusText = () => {
    switch (status) {
      case 'positive':
        return 'Positive';
      case 'negative':
        return 'Negative';
      case 'no-policy':
        return 'No Policy';
      case 'restricted':
        return 'Restricted';
      default:
        return 'Unknown';
    }
  };
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'h-3 w-3';
      case 'lg':
        return 'h-5 w-5';
      case 'md':
      default:
        return 'h-4 w-4';
    }
  };
  return <div className="flex items-center" data-id="element-185">
      <div className={`${getSizeClasses()} ${getStatusColor()} rounded-full`} data-id="element-186"></div>
      {showText && <span className="ml-2 text-sm font-medium text-gray-700" data-id="element-187">
          {getStatusText()}
        </span>}
    </div>;
};
export default StatusBadge;